import Image from 'next/image'
import Link from 'next/link'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useModal from 'src/common/components/Modal'
import ReferralModalContent from 'src/common/components/ReferralModalContent'
import { useUser, useUserReferralCode } from 'src/common/hooks/useUser'
import { getReferralCode } from 'src/services/mainAPI'

export type OfferProps = {
    variant: '1-month-free' | 'referral'
}

export const Offer = ({ variant }: OfferProps) => {
    const dispatch = useDispatch()
    const referralCode = useUserReferralCode()
    const user = useUser()
    const { isOpen, closeModal, toggle, Modal } = useModal()
    useEffect(() => {
        if (isOpen && user) {
            dispatch(
                getReferralCode.initiate(null, { subscribe: false, forceRefetch: true })
            )
        }
    }, [dispatch, isOpen, user])
    if (variant === '1-month-free') {
        return (
            <div className="bg-1-month-free-pattern flex w-full rounded-xl py-2 px-3 items-center cursor-pointer hover:opacity-75 transition-all">
                <div className="inline-flex mr-4">
                    <img src="/VIP-badge.svg" alt="premium svg" width={50} height={50} />
                </div>
                <div>
                    <Link href="/membership">
                        <div>
                            <p className="text-white text-lg md:text-md leading-tight">
                                Join the Exclusive Club
                            </p>
                            <p className="text-white text-xs sm:text-sm md:text-xs">
                                Try out VIP FREE For 30 days!
                            </p>
                        </div>
                    </Link>
                </div>
            </div>
        )
    }

    if (variant === 'referral') {
        return (
            <>
                <div
                    className="bg-referral-pattern transition-all flex w-full rounded-xl py-2 px-5 items-center select-none cursor-pointer hover:opacity-75 transition-all"
                    onClick={toggle}
                >
                    <div className="mr-2 md:mr-1 pt-2">
                        <p className="text-xl font-medium text-white">Give $5, Get $5</p>
                        <p className="text-xs md:text-sm text-white font-normal mb-2">
                            Everytime a new friend makes any purchase at Yes.Fit!
                        </p>
                        <button
                            className="bg-yf-green rounded px-2 py-1 text-xs text-white mb-2"
                            onClick={toggle}
                        >
                            Get My Code
                        </button>
                    </div>
                    <div>
                        <Image
                            src="/referral.svg"
                            alt="Referral SVG Image"
                            width={100}
                            height={100}
                        />
                    </div>
                </div>
                <Modal
                    content={
                        <ReferralModalContent
                            isLoggedIn={user ? true : false}
                            referralCode={referralCode}
                        />
                    }
                    isOpen={isOpen}
                    closeModal={closeModal}
                />
            </>
        )
    }

    return null
}
